import axios from 'axios';
import qs from 'qs';
import getApiUrl from "src/utils/get-api-url";

const apiUrl = getApiUrl();
const paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'repeat' });

/**
 * Get paginated Inactive Profiles records with optional filters.
 *
 * @param {Object} [filters]
 * @param {string} [filters.login]
 * @param {Array<string>} [filters.allianceAndGu]
 * @param {Array<string>} [filters.pdm]
 * @param {string} [filters.profileStatus]
 * @param {string} [filters.inactivationStartDate]
 * @param {string} [filters.inactivationEndDate]
 * @param {Object} [pagination]
 * @param {number} [pagination.currentPage]
 * @param {number} [pagination.limit]
 * @returns {Promise<Object>}
 */
export function list(filters = {}, pagination = {}, sort = {}) {
    return axios.get(`${apiUrl}/reports/inactivation`, {
        params: { ...filters, ...pagination, ...sort },
        paramsSerializer,
    });
}

/**
 * Get filter options for Inactive Profiles.
 *
 * @returns {Promise<Object>}
 */
export function getFilters() {
    return axios.get(`${apiUrl}/reports/inactivation/filters`);
}

/**
 * Export Inactive Profiles records in the specified format.
 *
 * @param {string} format - Export format: 'csv', 'xlsx' or 'pdf'.
 * @param {string} lang - Language code: 'en' or 'pt-BR'.
 * @returns {Promise<Object>}
 */
export function exportReport(format, lang) {
    return axios.get(`${apiUrl}/reports/inactivation/export`, {
        params: { format, lang },
        paramsSerializer,
        responseType: 'blob',
    });
}
